import { useAuth } from '../contexts/AuthContext';
import { AlertCircle } from 'lucide-react';
import { PermissionMatrix } from '../components/settings/PermissionMatrix';

export function PermissionMatrixPage() {
    const { user } = useAuth();

    if (!user?.isAdmin) {
        return (
            <div className="flex items-center gap-3 p-6 bg-red-50 rounded-lg">
                <AlertCircle className="w-5 h-5 text-red-600" />
                <p className="text-red-700">Access denied. Admin role required.</p>
            </div>
        );
    }

    return (
        <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-6">Permission Matrix</h1>
            <PermissionMatrix />
        </div>
    );
}
